<template>
  <div id="app">
  	<c-nav></c-nav>
    <router-view/>
    <c-footer></c-footer>
  </div>
</template>

<script>
import cNav from './components/nav';
import cFooter from './components/footer';
export default {
  name: 'App',
  components: {cNav,cFooter}
}
</script>

<style>
@import url("./assets/css/comm.css");
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background:#F5F5F5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue